export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-refresh-line',
      title: 'Updated Daily',
      description: 'Fresh links verified every 24 hours. Dead links are removed immediately so you always get working spreadsheets.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trusted Sellers',
      description: 'Every seller goes through community verification. Only QC-checked stores with positive reviews make our directory.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Fast Navigation',
      description: 'Jump to any category, brand, or product type in a single click. No clutter, no ads — just direct links.',
    },
    {
      icon: 'ri-file-search-line',
      title: 'Spreadsheet Verification',
      description: 'Our team manually checks spreadsheet quality before listing. Verified badges mark the most reliable resources.',
    },
    {
      icon: 'ri-book-read-line',
      title: 'Buying Guides',
      description: 'Comprehensive guides covering shipping, QC photos, agent comparison, and beginner tips accompany every category.',
    },
    {
      icon: 'ri-heart-line',
      title: 'Community Favorites',
      description: 'Top-voted spreadsheets rise to the top. See what the community is actually using and loving right now.',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-medium text-primary-600 tracking-widest uppercase">Why Choose Us</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 leading-tight">
            Built for <br className="md:hidden" />Buyers
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            We built this directory because we were tired of outdated spreadsheets and dead links. Here is what makes us different.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feat) => (
            <div key={feat.title} className="p-6 md:p-7 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200/50 transition-colors">
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-100 mb-4">
                <i className={`${feat.icon} text-lg md:text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}